const StationIntegrated = ({language , token}) => {
    const newStationIframe = "https:" +
    window.process.env.URL_Station
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_station_display"
        src={newStationIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default StationIntegrated